module.exports = "https://trybtryb-legacy.web.app/img/twitter_grey.18922346.svg";